import { useMemo } from 'react';

import { TabTableContainer } from 'components/layout/AppLayout/AppLayout.styled';
import DynamicList from 'components/list/DynamicList';
import { FilterType, ListComponents } from 'components/list/DynamicListFilterUtils';

import { CREDIT } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants';

/**
 * @author Burak Ak
 */
const FreeCreditTransactionList = () => {
	const columns = useMemo(
		() => [
			{ Header: 'ID', accessor: 'ID', filterType: FilterType.number, width: 70, show: false },
			{
				Header: 'promoCodeTitle',
				accessor: 'promoCode',
				filterType: FilterType.string,
				width: 90,
				showOnMobile: true
			},
			{
				Header: 'type',
				accessor: 'type',
				filterType: FilterType.multiSelection,
				width: 130,
				showOnMobile: true
			},
			{
				Header: 'description',
				accessor: 'description',
				filterType: FilterType.multiSelection,
				width: 200,
				show: false
			},
			{
				Header: 'givenAmount',
				accessor: 'givenAmount',
				filterType: FilterType.float,
				renderCell: ListComponents.CURRENCY,
				width: 80
			},
			{
				Header: 'remainingAmount',
				accessor: 'remainingAmount',
				filterType: FilterType.float,
				renderCell: ListComponents.CURRENCY,
				width: 80
			},
			{
				Header: 'expiryDate',
				accessor: 'expiryDate',
				filterType: FilterType.date,
				width: 80,
				renderCell: ListComponents.DATETIME,
				showOnMobile: true
			},
			{
				Header: 'shipmentType',
				accessor: 'shipmentType',
				filterType: FilterType.string
			},
			{
				Header: 'givenShipments',
				accessor: 'givenShipments',
				filterType: FilterType.float,
				width: 90
			},
			{
				Header: 'remainingShipments',
				accessor: 'remainingShipments',
				filterType: FilterType.float,
				width: 90
			}
		],
		[]
	);

	const defaultSort = useMemo(() => [{ id: 'ID', desc: true }], []);

	return (
		<TabTableContainer>
			<DynamicList
				id={DYNAMICLISTS.FREE_CREDIT_TRANSACTIONS}
				columns={columns}
				fetchUrl={CREDIT.GET_FREE_CREDIT_TRANSACTION_LIST}
				exportName="freeCreditTransactions"
				defaultSort={defaultSort}
			/>
		</TabTableContainer>
	);
};

export default FreeCreditTransactionList;
